export * from './components';
export * from './SchoolProfile';
export * from './styles';
export * from './TeacherProfile';